module.exports = __webpack_public_path__ + "static/media/section_3_icon_1.7e8abbce.png";